<template>
    <CContainer class="d-flex flex-column justify-content-between py-5 content-center min-vh-100 col-12">
            <CHeaderBrand class="mx-auto mb-3" to="/">
                <img class="w-25" src="../assets/logo.png">
            </CHeaderBrand>
            <CRow class="container col-12 d-flex flex-column justify-content-center align-content-center">
                <h1>Política de privacidade</h1>
                <p class="description">Esta Política de Privacidade aplica-se apenas às suas atividades online no nosso website e aplicação, dizendo respeito apenas à informação partilhada ou recolhida na consequências das suas açòes. Esta Poítica de Privacidade não é aplicável para qualquer informação recolhida offline ou através de outros canais que não o website.</p>
                <p class="description">Ao utilizar o nosso website e aplicação está a aceitar a nossa Política de Privacidade e a concordar com todos os termos.</p>
                <h2>Informação que recolhemos</h2>
                <p class="description">A informação pessoal que solicitamos, e as razões pelas quais a solicitamos, serão tornadas claras nessa mesma altura. É exemplo disso, do lado da aplicação móvel, o registo de operações. Do lado do backoffice, a informação é gerida de forma a ser refletida do lado da aplicação ou para gestão e supervisionamento das tarefas.</p>
                <p class="description">Caso nos contacte diretamente, poderemos obter informação pessoal adicional, por exemplo nome, email ou número de telefone, e conteúdos relativos à mensagem em questão.</p>
                <h2>Como utilizamos a informação que recolhemos</h2>
                <p class="description">A informação obtida é apenas utilizada para a gestão dos trabalhos ligados à Fundação Casa de Mateus, não sendo tratado por qualquer outra entidade externa. A Outsmartis, criadora do website, é exceção a esta regra mas apenas de forma indireta, sendo responsável pelo desenvolvimento da tecnologia mas não por qualquer processamento não anónimo da informação.</p>
            </CRow>
        <TheFooter class="col-12 w-100"/>
  </CContainer>
</template>

<script>
import TheHeader from '@/containers/TheHeader'
import TheFooter from '@/containers/TheFooter'

export default {
  name: 'TheContainer',
  components: {
    TheHeader,
    TheFooter
  }
}
</script>

<style scoped>
.description
{
    font-size: .875rem;
}

body > div > a > img
{
    min-width: 300px;
}

.container
{
    max-width: 1300px;
}
</style>